import { SideContent } from "src/style"
import { ChatLayout, NotificationLayout } from "src/component"


export const Chats: React.FC<any> = ({}) => {

    return (
        <SideContent topPadding="12" overflow="hidden">
            <ChatLayout/>
        </SideContent>
    )
}